<template>
    <div class="ad ad-small">
        <a href='https://promotion.aliyun.com/ntms/act/qwbk.html?userCode=l1qstn8f' target=_blank>
            <img src='http://menhu.yangqq.com/d/file/p/2019/05-11/c58f3150b86b1cad751bff3e094b09fc.jpg' border=0
            width='320' height='140' alt=''>
        </a>
    </div>
</template>

<script>
    export default {
        name: "ImgAd"
    }
</script>

<style scoped>

</style>